import bitsByWordsCount from "../../static/bitsByWordCount.json";
import {
  Card,
  CardContent,
  Typography,
  LinearProgress,
  ButtonGroup,
  Button,
  Box,
} from "@mui/material";
import {
  Backspace as UndoIcon,
  Delete as ResetIcon,
  DoneAll as AutoFillIcon,
} from "@mui/icons-material";

function Entropy({ diceNumbers, setDiceNumbers, wordsCount }) {
  function calculateMadeEntropyLength() {
    return diceNumbers.map((e) => Number(e).toString(2)).join("").length;
  }

  function onClickNumberButton(event) {
    if (calculateMadeEntropyLength() >= bitsByWordsCount[wordsCount]) {
      return;
    }
    setDiceNumbers([...diceNumbers, Number(event.target.value)]);
  }

  function onClickAutoFillButton() {
    function rollDice() {
      return Math.floor(Math.random() * 6) + 1;
    }
    while (calculateMadeEntropyLength() < bitsByWordsCount[wordsCount]) {
      diceNumbers.push(rollDice());
    }
    setDiceNumbers([...diceNumbers]);
  }

  function onClickUndoButton() {
    diceNumbers.pop();
    setDiceNumbers([...diceNumbers]);
  }

  const entropyLength = calculateMadeEntropyLength();
  const requiredEntropy = bitsByWordsCount[wordsCount];
  const progress = Math.min((entropyLength / requiredEntropy) * 100, 100);

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" component="h2" gutterBottom>
          2. Generate Your Own Entropy
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Please select the numbers that came up when you rolled a real die.
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box sx={{ width: "100%", mr: 1 }}>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
          <Box sx={{ minWidth: 120 }}>
            <Typography variant="body2" color="text.secondary">{`${Math.round(
              entropyLength
            )} / ${requiredEntropy} bits`}</Typography>
          </Box>
        </Box>
        <ButtonGroup
          variant="contained"
          aria-label="dice number buttons"
          sx={{ mb: 2 }}
        >
          {[1, 2, 3, 4, 5, 6].map((e) => (
            <Button
              key={e}
              value={e}
              onClick={onClickNumberButton}
              sx={{ width: "50px", height: "50px", fontSize: "1.2rem" }}
            >
              {e}
            </Button>
          ))}
        </ButtonGroup>
        <ButtonGroup variant="outlined" aria-label="control buttons">
          <Button
            onClick={() => setDiceNumbers([])}
            color="error"
            startIcon={<ResetIcon />}
          >
            Reset
          </Button>
          <Button
            onClick={onClickAutoFillButton}
            color="success"
            startIcon={<AutoFillIcon />}
          >
            Auto-fill
          </Button>
          <Button
            onClick={onClickUndoButton}
            color="warning"
            startIcon={<UndoIcon />}
          >
            Undo
          </Button>
        </ButtonGroup>
      </CardContent>
    </Card>
  );
}

export default Entropy;
